import { DateTime } from 'luxon';

import { UserSubscription } from '@appTypes/esb';

import { subscriptionIds } from '../constants';
import getActiveSubscription from './getActiveSubscription';

const getSub = (
  currentSubs: UserSubscription[],
  subId: number | string,
  wantsOptOut: boolean,
): UserSubscription | undefined => {
  const sub = getActiveSubscription(currentSubs, subId);

  if (!sub) {
    return {
      topicId: subId as number,
      optOutFlag: wantsOptOut,
      effectiveDt: DateTime.now().toISODate(),
    } as UserSubscription;
  }

  if (sub.optOutFlag !== wantsOptOut) {
    return {
      ...sub,
      optOutFlag: wantsOptOut,
      expiryDt: sub.expiryDt ? sub.expiryDt : null,
    };
  }

  return undefined;
};

export default function formatSubscriptions(
  formOptOut?: string[],
  currentSubs: UserSubscription[] = [],
): UserSubscription[] {
  const result: UserSubscription[] = [];

  if (!formOptOut) return result;

  const wantsOptOut = !!formOptOut.length;

  const reminderSub = getSub(
    currentSubs,
    subscriptionIds.REMINDERS,
    wantsOptOut,
  );

  if (reminderSub) {
    result.push(reminderSub);
  }

  return result;
}
